module.exports = __webpack_public_path__ + "img/allowed-format-c.8e61ef1f.png";